import React, { Component } from 'react'
import { isNumber } from 'lodash'
import {
  Modal, Checkbox, Well, Glyphicon
} from 'react-bootstrap'

import Button from '../components/Button.jsx'
import { dictWithKeys } from '../../lib/Tools'
import { getTripFiles } from '../../lib/TripTools'

import { nameOrTitle, getText } from '../lib/text.js'

/**
 * Shows the pages in the proposal pdf and allows the user to pick or omit pages
 */

type Props = {
  trip: Object,
  route: Object,
  allActivities: Object,
  Cities: Object,
  onGenerate: Function,
  onCancel: Function
}

class DocPagesModal extends React.PureComponent
{
  constructor(props) {
    super(props)

    // state === ids of the selected optional docs (blocks and activities)
    // (dictionary with the activity ids, to check whether one is selected or not)

    const defaultFiles = getTripFiles(props.trip, props.route, props.allActivities, props.Cities)
      .filter(piece => piece.type === "activity" || piece.type === "description")
      .filter(piece => piece.files && (piece.files.doc1Page || piece.files.descriptionPDF))
      .map(x => x._id)

    defaultFiles.push("ticket")

    this.state = dictWithKeys(defaultFiles)
  }

  props : Props

  render() {
    // x represents a file. it might be a block, an activity, or any other kind of piece
    // it has: _id, name, fixed? and files?

    const MyCheckbox = ({ x, children }) => (
      <Checkbox
        checked={x.fixed || this.state[x._id]}
        disabled={x.fixed || (x.type === "activity" && (!x.files && x.files.doc1Page))}
        onChange={evt => this.setState({[x._id]: evt.target.checked})}
      >
        {children}
      </Checkbox>
    )

    const noFileLabel = <span style={{fontStyle: "italic", color: "grey"}}>({getText("sin fichero")})</span>

    const Item = ({ x }) => (
      <MyCheckbox x={x}>
        <em>{isNumber(x.days) ? "Etapa: " : ""}</em>
        {nameOrTitle(x)} {x.type === "activity" && (!x.files || !x.files.doc1Page) ? noFileLabel : ""}
      </MyCheckbox>
    )

    const { trip, allActivities, Cities, route } = this.props
    const doc: Array<Object> = getTripFiles(trip, route, allActivities, Cities)

    return (
      <Modal show onHide={() => this.props.onCancel()}>
        <Modal.Header closeButton>
          <Modal.Title>{getText("Contenido del documento")} (<Glyphicon glyph="star" />)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Well bsSize="small">{getText("docpagesmodal_msg")}</Well>
          <ul>
            {
              doc.map(x => (<li key={x._id}><Item x={x} /></li>))
            }
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.props.onCancel()}>{getText("Cancelar")}</Button>
          <Button bsStyle="primary" onClick={() => this.props.onGenerate(this.state)}>OK</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}


export default DocPagesModal
